module.exports = __webpack_public_path__ + "static/media/Direct-Air-Capture.45e020d6.svg";